import { Dispatch, SetStateAction } from "react";
import FilterButton from "./FilterButton";
import searchGlass from "@/icons/search2.svg";
import filterContent from "./filterContent"


const CategoryFilters = ({
  selected,
  setSelected,
}: {
  selected: string;
  setSelected: Dispatch<SetStateAction<string>>;
}) => {
  return (
    <div>
      <div className="flex items-center text-charcoal mt-[48px]">
        <img
        src={searchGlass}
        alt=""
        className="h-[21px] w-[20px] text-charcoal  mr-[8px] mb-[26px]"
      />

        <h2 id="examples" className="mb-[24px] font-medium text-[16px] sm:text-[24px] leading-[24px] text-charcoal">
        {retailCategoriesDetails.sectionHeading}
        </h2>
      </div>
      <div className="flex flex-wrap gap-2 mb-[24px]">
        {filterContent.map((filter) => {
          return (
            <FilterButton
              key={filter.name}
              src={filter.src}
              text={filter.name}
              selected={selected}
              setSelected={setSelected}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CategoryFilters;
